<template>
  <div class="outrerBox" ref="scrollContainer" @scroll="handleScroll">
    <div class="top">
      <div class="top-box">
        <button
          ref="bailianBtn"
          class="bailian-button"
          @mouseenter="onMouseEnter"
          @mouseleave="onMouseLeave"
        >
          <!-- 注册 -->
          <span class="glow" ref="glow"></span>
        </button>
      </div>
    </div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(slide, index) in slides" :key="index">
          <div class="slide-content">
            <div class="text-line">{{ slide.title }}</div>
            <div class="des1">{{ slide.des1 }}</div>
            <div class="des2">{{ slide.des2 }}</div>
            <div class="des3">{{ slide.des3 }}</div>
          </div>
        </div>
      </div>
      <!-- 左右切换按钮 -->
      <div class="swiper-button-next swiper-nav"></div>
      <div class="swiper-button-prev swiper-nav"></div>

      <!-- 分页指示器 -->
      <div class="swiper-pagination"></div>
    </div>
    <div class="tips-box">
      <div class="tips-box-inner">
        <div class="tips-inners">
          <div class="container">
            <div class="box">
              <div class="front">
                <div class="icon">
                  <img class="img" src="@/assets/image/hosp.png" alt />
                </div>
                <span>互联网医院</span>
              </div>
              <div class="back">
                <span>互联网医院</span>
                <p>我们用科技连接患者与医生，构建起一个全方位、个性化的医院闭环互联网医院平台</p>
              </div>
            </div>
            <div class="box">
              <div class="front">
                <div class="icon">
                  <img class="img" src="@/assets/image/store.png" alt />
                </div>
                <span>医路伴学</span>
              </div>
              <div class="back">
                <span>医路伴学</span>
                <p>学生之间模拟客观结构化临床考试的联系学习应用，包含互相点评、互相学习，名师点评，模拟考试等模块。</p>
              </div>
            </div>
            <div class="box">
              <div class="front">
                <div class="icon">
                  <img class="img" src="@/assets/image/submitAccount.png" alt />
                </div>
                <span>医保报销助手</span>
              </div>
              <div class="back">
                <span>医保报销助手</span>
                <p>医保报销助手医保报销助手医保报销助手医保报销助手</p>
              </div>
            </div>
            <div class="box">
              <div class="front">
                <div class="icon">
                  <img class="img" src="@/assets/image/prescriptionRoam.png" alt />
                </div>
                <span>处方流转</span>
              </div>
              <div class="back">
                <span>处方流转</span>
                <p>处方流转处方流转处方流转处方流转处方流转处方流转</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nap-box">
      <a-affix :offset-top="80">
        <div :class="['nap-container', scrollTop >= 590 ? 'nap-container1' : '']">
          <div class="nap-inner">
            <div class="item flex" @click="goDingyue(1)">
              <img class="img" src="@/assets/image/hosp.png" alt />
              <div class="item-des">
                <h2>互联网医院</h2>
                <!-- <p>为医院带来一种全新的医疗服务体验，将高效、便捷与专业融为一体</p> -->
              </div>
            </div>
            <div class="item flex" @click="goDingyue(2)">
              <img class="img" src="@/assets/image/store.png" alt />
              <div class="item-des">
                <h2>医路伴学</h2>
                <!-- <p>为医院带来一种全新的医疗服务体验，将高效、便捷与专业融为一体</p> -->
              </div>
            </div>
            <div class="item flex" @click="goDingyue(3)">
              <img class="img" src="@/assets/image/submitAccount.png" alt />
              <div class="item-des">
                <h2>医保报销助手</h2>
                <!-- <p>为医院带来一种全新的医疗服务体验，将高效、便捷与专业融为一体</p> -->
              </div>
            </div>
            <div class="item flex" @click="goDingyue(4)">
              <img class="img" src="@/assets/image/prescriptionRoam.png" alt />
              <div class="item-des">
                <h2>处方流转</h2>
                <!-- <p>为医院带来一种全新的医疗服务体验，将高效、便捷与专业融为一体</p> -->
              </div>
            </div>
          </div>
        </div>
      </a-affix>
    </div>
    <div class="innerContent">
      <!-- 互联网医院 start -->
      <div :class="['content_box', 'content_box1', content_box1_flag ? 'content_box1_active' : '']" ref='content_box1'>
        <div class="descBox">
          <div class="desc1">互联网医院</div>
          <div class="desc2">
            <div>我们为医院带来一种全新的医疗服务体验，将高效、便捷与专业融为一体。我们用科技连</div>
            <div>接患者与医生，构建起一个全方位、个性化的医院闭环互联网医院平台。我们利用先进的</div>
            <div>信息技术，为互联网医院保驾护航。</div>
          </div>
          <div class="desc3">
            <div>我们的服务已经在众多医院得到了广泛的好评。从诊前的智能导诊，预问诊，到诊中的问诊、处方流</div>
            <div>转，到诊后的随访，慢性病管理，再到日常的健康咨询，我们的团队协助医院以高度的专业性和贴心</div>
            <div>关怀，赢得了患者的信任。每一个成功的案例都证明了我们服务的实用性与可靠性。</div>
          </div>
        </div>
        <div class="imgBox">
          <img class="innerImg" src="@/assets/image/Bg/hulianwangyiyuan.gif" />
        </div>
      </div>
      <!-- 互联网医院 end -->
      <!-- 医路伴学 start -->
      <div class="content_box content_box2">
        <div class="highDoTitle">
          <span>医路伴学</span> 
        </div>
        <div class="content_box2_imgBox">
          <img style="height: 400px;margin: 0 20px;" src="@/assets/image/yi_lu_ban_xue/bg1.png" alt />
          <img style="height: 400px;margin: 0 20px;" src="@/assets/image/yi_lu_ban_xue/bg2.png" alt />
          <img style="height: 400px;margin: 0 20px;" src="@/assets/image/yi_lu_ban_xue/bg3.png" alt />
        </div>
        <div class="des">
          医路伴学软件为用户提供了一个自我提升的平台，用户可以在软件上上传自己的操作视频，上传完视频后可自行对视频进行编辑在不同的时间点插入点评点，点评点为视频的某一段视频记录，可以添加自己的理解笔记，以供后续复盘使用
        </div>
      </div>
      <!-- 医路伴学 end -->
      <!-- 医保报销助手 start -->
      <div class="content_box content_box3">
        
      </div>
      <!-- 医保报销助手 end -->
    </div>

    <div class="mySelf">
      <div class="titleInHome">
        <div class="text" data-text="公司简介">公司简介</div>
      </div>
      <div class="subtitle">一个开拓进取，敢于挑战传统的冉冉新星</div>
      <div class="thirdLists">
        <img class="thirdImg" src="@/assets/image/company.png" />
        <div class="listTitle">
          <div
            class="des"
          >辽宁省元一网络科技有限公司成立于2023年，致力于将人工智能技术应用于医疗医药科技领域，旨在提高医疗效率和患者用药效率，为提高患者的用药效果提供技术与服务支持，公司的服务已经获得了众多客户的认可和好评。已经与国内多家知名医院与零售药店合作。</div>
          <div
            class="des"
          >技术团队拥有人工智能算法、深度学习模型和自然语言处理等方面的核心技术能力。这些技术能够根据庞大的医疗数据进行分析和学习，以提供更加精准用药建议。我们的技术团队由多名具有丰富经验的工程师组成，团队人工智能和医疗领域有深入的理解和独特的见解。</div>
        </div>
      </div>
      <div class="containerChongDian">
        <div class="outer">
          <div class="circle"></div>
        </div>
        <div class="outer">
          <div class="circle" style="transform: scale(.96)"></div>
        </div>
        <div class="outer">
          <div class="circle" style="transform: scale(.92);"></div>
        </div>
        <div class="line-box">
          <div class="line-left"></div>
          <div class="line-left line-right"></div>
          <div class="line-center line-center-left-2"></div>
          <div class="line-center line-center-left-1"></div>
          <div class="line-center"></div>
          <div class="line-center line-center-right-1"></div>
          <div class="line-center line-center-right-2"></div>
        </div>
        <div class="outer" style="transform: scale(.68);">
          <div class="circle circle-blur" style="padding: 30px;"></div>
        </div>
        <div class="outer">
          <div class="circle-white"></div>
        </div>
        <div class="outer" style="transform: scale(.98);animation-duration: 480ms;">
          <div class="circle-white"></div>
        </div>
        <div class="outer" style="transform: scale(.96);animation-duration: 460ms;">
          <div class="circle-white"></div>
        </div>
        <div class="outer" style="transform: scale(.94);animation-duration: 440ms;">
          <div class="circle-white"></div>
        </div>

        <div class="light"></div>
      </div>
    </div>
    <div class="ourDream">
      <div class="txtwav flip theTitle">企业文化</div>
      <!-- <div class="box">
        <div class="txtwav slow theTitleDes theTitleDes1">
          我们以客户为中心，全力以赴创造价值
        </div>

        <div class="txtwav vibe theTitleDes theTitleDes1">
          我们以客户为中心，全力以赴创造价值
        </div>

        <div class="txtwav bounce theTitleDes theTitleDes1">
          我们以客户为中心，全力以赴创造价值
        </div>

        <div class="txtwav flip theTitleDes theTitleDes1">
          我们以客户为中心，全力以赴创造价值
        </div>
      </div>-->
      <div class="txtwav bounce theTitleDes theTitleDes1">我们以客户为中心，全力以赴创造价值</div>
      <div class="txtwav bounce theTitleDes theTitleDes1">我们是开放团队，正直互信合作共赢</div>
      <div class="txtwav bounce theTitleDes theTitleDes1">我们是创业者，主动担当锐意变革</div>
      <div class="txtwav bounce theTitleDes theTitleDes1">我们是创新者，坚持不懈推陈创新</div>
      <div class="txtwav bounce theTitleDes theTitleDes1">我们说到做到、尽心尽力、成就客户</div>
    </div>
    <div class="ourMission">
      <div class="theTitle">
        <div class="theTitleInner" data-text="企业使命">
          <span>企业使命</span>
        </div>
      </div>
      <div class="txtwav theTitleDes theTitleDes1">作为医疗信息化行业的领导者引领健康领域产业链变革，</div>
      <div class="txtwav theTitleDes theTitleDes1">为提升中国的医疗水平赋能</div>
      <!-- <div class="theTitleDes theTitleDes1">作为医疗信息化行业的领导者引领健康领域产业链变革，</div>
      <div class="theTitleDes theTitleDes1">为提升中国的医疗水平赋能</div>-->
    </div>
    <foot></foot>
  </div>
</template>
<script>
import "swiper/css/swiper.css";
import foot from '@/components/foot/index.vue'
import Swiper from "swiper";
import { TweenMax } from "gsap";
setTimeout(() => {
  (function() {
    var n = document.getElementsByClassName("txtwav");
    for (var e = 0, t = n.length; e < t; e++) {
      var a = n[e],
        r = a.textContent.trim();
      a.innerHTML = null;
      i(a, r);
    }
    console.log("zxxxxsvv");
    function i(n, e) {
      for (var t in e) {
        var a = document.createElement("span");
        a.innerHTML = e[t] === " " ? "&nbsp;" : e[t];
        n.appendChild(a);
      }
    }
  })();
}, 1000);
export default {
  components: {
    foot,
  },
  data() {
    return {
      scrollTop: 0,
      content_box1_flag: false,
      slides: [
        {
          title: "互联网医院",
          des1: "我们为医院带来一种全新的医疗服务体验，将高效、便捷与专业融为一体。我们用科技连",
          des2: "接患者与医生，构建起一个全方位、个性化的医院闭环互联网医院平台。我们利用先进的",
          des3: "信息技术，为互联网医院保驾护航。"
        },
        {
          title: "医路伴学",
          des1: "学生之间模拟客观结构化临床考试的联系学习应用",
          des2: "包含互相点评、互相学习",
        },
        {
          title: "医保报销助手",
          des1: "医保报销助手",
          des2: "",
          des3: ""
        }
      ]
    };
  },
  created() {
  },
  mounted() {
    this.initSwiper();
    this.$refs.bailianBtn.addEventListener("mousemove", this.onMouseMove);
    window.addEventListener('scroll',this.yyy,true);
    setTimeout(() => {
      console.log(window.innerHeight, '可视高度')
      console.log(this.$refs.content_box1.getBoundingClientRect().top)
    }, 10);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.yyy,true);
  },
  methods: {
    yyy(){
      this.content_box1_flag = (this.$refs.content_box1.getBoundingClientRect().top - ( window.innerHeight / 2 ) < 0) ? true : false
      console.log(this.content_box1_flag, '可视高度')

    },
    initSwiper() {
      new Swiper(".swiper-container", {
        loop: true, // 循环播放
        autoplay: {
          delay: 50000, // 自动播放间隔
          disableOnInteraction: false // 交互后继续播放
        },
        speed: 500, // 切换动画速度
        pagination: {
          el: ".swiper-pagination",
          clickable: true // 允许点击分页切换
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    },

    onMouseMove(event) {
      const btn = this.$refs.bailianBtn;
      const glow = this.$refs.glow;
      const rect = btn.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      glow.style.left = `${x}px`;
      glow.style.top = `${y}px`;
    },
    onMouseEnter() {
      TweenMax.to(this.$refs.bailianBtn, 0.3, {
        scale: 1.01,
        boxShadow: "0px 0px 20px rgba(0, 255, 255, 0.6)"
      });
    },
    onMouseLeave() {
      TweenMax.to(this.$refs.bailianBtn, 0.3, {
        scale: 1,
        boxShadow: "0px 0px 10px rgba(0, 255, 255, 0.3)"
      });
    },
    // 返回顶部
    backUp() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    goDingyue(val) {
      // console.log(this.$refs.content_box_ref.getBoundingClientRect());
      this.$el
        .querySelector(`.content_box${val}`)
        .scrollIntoView({ block: "start", behavior: "smooth" });
    },
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "../assets/css/94.css";
.outrerBox {
  background: linear-gradient(90deg, rgb(237, 242, 250), rgb(230, 236, 245));
}
/* Swiper 容器 */
.swiper-container {
  width: 100%;
  height: 500px;
  position: relative;
  background: linear-gradient(45deg, #4a90e2, #9013fe);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* 幻灯片 */
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  height: 100%;
}

/* 分页指示器 */
.swiper-pagination {
  position: absolute;
  bottom: 10px;
}

/* 左右切换按钮 */
.swiper-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.swiper-button-next {
  right: 10px;
  transform: rotate(45deg);
  border-radius: 4px;
}
.swiper-button-next:after {
  transform: rotate(-45deg);
  font-size: 16px;
}

.swiper-button-prev {
  left: 10px;
  transform: rotate(-45deg);
  border-radius: 4px;
}
.swiper-button-prev:after {
  transform: rotate(45deg);
  font-size: 16px;
}

.swiper-nav:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.slide-content {
  width: 100%;
  .text-line {
    width: 100%;
    padding-left: 400px;
    opacity: 0;
  }
  .des1,
  .des2,
  .des3 {
    width: 100%;
    padding-left: 400px;
    opacity: 0;
  }
}
.swiper-pagination {
  bottom: 100px;
}
.swiper-slide {
  padding-bottom: 80px;
}
.swiper-slide-active {
  .slide-content {
    .text-line {
      padding-left: 0;
      opacity: 1;
      transition: all 0.8s;
      transition-delay: 0;
    }
    .des1,
    .des2,
    .des3 {
      width: 100%;
      padding-left: 0;
      opacity: 1;
      transition: all 0.8s;
    }
    .des1 {
      transition-delay: 0.2s;
    }
    .des2 {
      transition-delay: 0.3s;
    }
    .des3 {
      transition-delay: 0.4s;
    }
  }
}

// header
.top {
  height: 1px;
  position: relative;
  .top-box {
    height: 80px;
    width: 100%;
    background: rgba(0, 0, 0, 0.648);
    backdrop-filter: blur(10px);
    z-index: 1000;
    position: absolute;
    top: 0;
  }
}

// tips
.tips-box {
  height: 110px;
  width: 100%;
  position: relative;
  .tips-box-inner {
    height: 220px;
    width: 100%;
    // background: rgba(43, 226, 110, 0.498);
    position: absolute;
    top: -90px;
    z-index: 10000;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .tips-inners {
      background: rgba(0, 0, 0, 0.429);
      backdrop-filter: blur(2px);
      box-shadow: 0px 2px 5px rgba(25, 40, 80, 0.5);
      padding: 0 10px;
      width: 1200px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tips-list {
        background: pink;
        height: 100px;
        flex: 1;
        margin: 0 10px;
        border-radius: 6px;
      }
    }
  }
}
.bailian-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #0d0d0d;
}

.bailian-button {
  position: relative;
  padding: 15px 40px;
  font-size: 18px;
  color: white;
  background: linear-gradient(45deg, #00c6ff, #0072ff);
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 255, 255, 0.3);
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

.bailian-button .glow {
  position: absolute;
  width: 100px;
  height: 100px;
  background: radial-gradient(circle, rgba(0, 255, 255, 0.6), transparent);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
.nap-box {
  position: relative;
  height: 1px;
  width: 100%;

  .nap-container {
    width: 100%;
    position: absolute;
    top: -80px;
    z-index: 1000;
    height: 80px;
    backdrop-filter: blur(5px);
    background-color: rgba(255, 255, 255, 1);

    .nap-inner {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;

      .item {
        flex: 1;
        padding: 0 20px;
        cursor: pointer;

        .img {
          height: 40px;
          width: 40px;
          margin-right: 10px;
        }

        .item-des {
          h2 {
            font-weight: 600;
            margin: 0;
          }

          p {
            margin: 0;
            color: #525151;
          }
        }
      }
    }
  }

  .nap-container1 {
    background: #fff;
    box-shadow: 0px 2px 5px rgba(25, 40, 80, 0.2);
  }
}
// 公司简介
.mySelf {
  background: url("@/assets/image/bg5.jpg") no-repeat 50%;
  background-size: cover;
  min-height: 566px;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  clip-path: ellipse(150% 101% at 50% 0%);
  position: relative;
  .titleInHome {
    height: 53px;
    width: 100%;
    font-size: 38px;
    font-weight: 500;
    color: #fff;
    line-height: 53px;
    margin-bottom: 13px;
    .text {
      flex: 0 0 100%;
      font-size: 40px;
      font-weight: 700;
      color: #00000000;
      text-align: center;
      font-family: "Lato", sans-serif;
      width: 100%;
      // position: absolute;
      // left: 50%;
      // top: 50%;
      transform: translate(0, 0);
      // background: url('@/assets/image/1.gif');
      background-clip: text;
      -webkit-background-clip: text;
      background-size: 20%;
    }

    .text:after {
      content: attr(data-text);
      width: 100%;
      -webkit-text-stroke: 1px rgb(246, 247, 248);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -49%);
      background: url("@/assets/image/1.gif");
      background-clip: text;
      -webkit-background-clip: text;
      background-size: 10%;
    }
  }
  .subtitle {
    height: 39px;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    line-height: 39px;
    opacity: 0.8;
  }
  .thirdLists {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 40px;
    .thirdImg {
      height: 140px;
      width: 140px;
      margin-right: 60px;
      position: absolute;
      left: 220px;
      bottom: 300px;
    }

    .listTitle {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;
      color: #fff;
      opacity: 0.99;
      font-size: 16px;
      .des {
        width: 800px;
        line-height: 34px;
        text-indent: 40px;
        text-align: left;
      }
    }
  }
}

// 公司理念
.ourDream {
  background: url("@/assets/image/ourDreamBg.png") no-repeat 50%;
  background-size: cover;
  min-height: 466px;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // clip-path: ellipse(120% 105% at 50% 0%);
  color: #333;
  .theTitle {
    font-size: 38px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .theTitleDes {
    font-size: 22px;
    padding-bottom: 10px;
  }
}

// 企业使命
.ourMission {
  background: url("@/assets/image/ourMission.jpg") no-repeat 50%;
  background-size: cover;
  min-height: 466px;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // clip-path: ellipse(120% 105% at 50% 0%);
  color: #fff;
  .theTitle {
    font-size: 38px;
    font-weight: 500;
    margin-bottom: 40px;
  }
  .theTitleDes {
    font-size: 26px;
    padding-bottom: 10px;
  }
}

// 互联网医院
.innerContent{
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  .content_box1{
    background: url("@/assets/image/Bg/bg1.png") no-repeat 50%;
    background-size: cover;
    min-height: 753px;
    padding: 50px 56px;
    display: flex;
    .descBox{
      max-width: 652px;
      padding-left: 10px;
      word-break: break-all;
      text-align: start;
      opacity: .5;
      transition: all 0.5s;
      .desc1{
        padding-left: 140px;
        opacity: 0;
        transition: all 0.5s;
        transition-delay: 0;
        height: 50px;
        line-height: 50px;
        font-size: 30px;
        font-weight: 600;
        color: #fff;
        background: -webkit-linear-gradient(90deg, #50edff, #557cff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        transition: all 0.5s;
        transition-delay: 0;
      }
      .desc2{
        width: 1200px;
        padding-left: 140px;
        opacity: 0;
        transition: all 0.5s;
        transition-delay: 0.2s;
        height: 72px;
        font-size: 16px;
        font-weight: 500;
        color: #69daf5;
        line-height: 36px;
        margin-top: 97px;
      }
      .desc3{
        width: 1200px;
        padding-left: 140px;
        opacity: 0;
        transition: all 0.5s;
        transition-delay: 0.4s;
        height: 108px;
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        line-height: 30px;
        margin-top: 70px;
      }
    }
    .imgBox{
      display: flex;
      align-items: center;
      justify-content: center;
      .innerImg{
        margin-left: 160px;
        height: 280px;
        width: 280px;
        opacity: 0;
        transition: all 0.2s;
      }
    }
    
  }
  .content_box1_active{
    .descBox{
      opacity: 1;
      transition: all 0.5s;
      .desc1{
        padding-left: 0;
        opacity: 1;
        transition: all 0.5s;
        transition-delay: 0;
      }
      .desc2{
        padding-left: 0;
        opacity: 1;
        transition: all 0.5s;
        transition-delay: 0.2s;
      }
      .desc3{
        padding-left: 0;
        opacity: 1;
        transition: all 0.5s;
        transition-delay: 0.4s;
      }
    }
    .imgBox{
      .innerImg{
        margin-left: 100px;
        opacity: 1;
        transition: all 0.2s;
      }
    }
  }
  .content_box2{
    background: url("@/assets/image/Bg/bg3.png") no-repeat 50%;
    background-size: cover;
    height: 710px;
    padding-left: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // opacity: .3;
    transition: 2s;    
    .highDoTitle{
      display: inline-block;
      font-size: 36px;
      font-weight: 600;
      margin-bottom: 26px;
      background: -webkit-linear-gradient(1deg, #6d66ff 12%, #c148ff 57%, #f59f77 76%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      line-height: 50px;
      margin-top: 20px;
      border-bottom: 1px solid #d4d4d5;
    }
    .content_box2_imgBox{
      height: 400px;
      width: 900px;
      background: rgba(238, 232, 170, 0.9);
      backdrop-filter: blur(4px);
      border-radius: 10px;
    }
    .des{
      text-align: center;
      max-width: 869px;
      line-height: 30px;
      color: #69daf5;
      font-weight: 400;
      font-size: 16px;
      margin-top: 30px;
    }
  }
  .content_box3{
    background: url("@/assets/image/Bg/bg3.png") no-repeat 50%;
    background-size: cover;
    height: 710px;
    padding-left: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // opacity: .3;
    transition: 2s;
  }
}
</style>